import component from "./TicketManager";

export default component;
